import request from './request'

/**
 * 待办事项 API
 */
export const todoApi = {
  /**
   * 获取待办列表
   * @param {Object} params - 查询参数
   * @param {number} params.status - 状态筛选: 0-待办 1-已完成 2-已逾期 3-已取消 4-进行中
   * @param {number} params.priority - 优先级筛选: 1-低 2-中 3-高 4-紧急
   * @param {string} params.keyword - 关键词搜索
   * @param {string} params.dueDateStart - 到期时间开始
   * @param {string} params.dueDateEnd - 到期时间结束
   * @param {number} params.categoryId - 分类ID
   * @param {number} params.pageNum - 页码
   * @param {number} params.pageSize - 页大小
   */
  getList(params) {
    return request({
      url: '/todos',
      method: 'get',
      params
    })
  },

  /**
   * 获取待办详情
   * @param {number} id - 待办ID
   */
  getDetail(id) {
    return request({
      url: `/todos/${id}`,
      method: 'get'
    })
  },

  /**
   * 创建待办
   * @param {Object} data - 创建数据
   * @param {number} data.userId - 负责人ID
   * @param {string} data.title - 待办标题
   * @param {string} data.description - 待办描述
   * @param {number} data.priority - 优先级
   * @param {string} data.dueDate - 到期时间
   * @param {string} data.sourceType - 来源类型
   * @param {string} data.sourceId - 来源ID
   */
  create(data) {
    return request({
      url: '/todos',
      method: 'post',
      data
    })
  },

  /**
   * 完成任务
   * @param {number} id - 待办ID
   */
  complete(id) {
    return request({
      url: `/todos/${id}/complete`,
      method: 'put'
    })
  },

  /**
   * 批量完成
   * @param {number[]} ids - 待办ID列表
   */
  batchComplete(ids) {
    return request({
      url: '/todos/batch/complete',
      method: 'put',
      data: { ids }
    })
  },

  /**
   * 批量更新状态
   * @param {Object} data - 更新数据
   * @param {number[]} data.ids - 待办ID列表
   * @param {number} data.status - 目标状态: 0-待办 1-已完成 2-已逾期 3-已取消 4-进行中
   */
  batchStatus(data) {
    return request({
      url: '/todos/batch/status',
      method: 'put',
      data
    })
  },

  /**
   * 批量删除
   * @param {number[]} ids - 待办ID列表
   */
  batchDelete(ids) {
    return request({
      url: '/todos/batch',
      method: 'delete',
      data: { ids }
    })
  }
}

export default todoApi
